import React, { useMemo } from 'react';

import styles from './StarredBoardsListItemSkeleton.less';

function randomIntBetween(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

interface StarredBoardsListItemSkeletonProps {}

export const StarredBoardsListItemSkeleton: React.FC<StarredBoardsListItemSkeletonProps> = () => {
  const placeholderWidth = useMemo(() => {
    return randomIntBetween(40, 80);
  }, []);

  return (
    <li className={styles.listItemSkeleton}>
      <div className={styles.boardAvatarSkeleton}></div>
      <div
        className={styles.boardNameSkeleton}
        style={{
          width: `${placeholderWidth}%`,
        }}
      ></div>
    </li>
  );
};
